import styled from '@emotion/styled';
import { theme } from 'theme';

export const SwitchesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5em;
  padding-top: 0.5em;
  .gps_compliant_switch {
    order: -1;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    ${theme.breakpoints.down(767)} {
      padding-bottom: 20px;
    }
    .MuiTypography-root {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #da1e10; // Gensler Brand red color
    }
  }
`;
